import React from 'react';
import Moment from 'moment';
import { formatDisplayDate } from '../../../utilities/displayFormat';

// Shared between MedicationModal and NonMedicationModal (both attendance.js
// and the notification-driven versions show a list of a student's
// medication/non-medication records the same way).
export const MEDICATION_BUCKET_META = {
  ongoing: { label: 'Ongoing', bg: '#dcfce7', color: '#166534', icon: 'ri-checkbox-circle-fill' },
  upcoming: { label: 'Upcoming', bg: '#fef9c3', color: '#854d0e', icon: 'ri-time-line' },
  past: { label: 'Past', bg: '#f3f4f6', color: '#6b7280', icon: 'ri-history-line' },
};

// Ongoing = today falls inside [date_start, date_end]; upcoming = date_start
// is still in the future; past = date_end has already passed.
export function getMedicationRecordBucket(record) {
  const today = Moment().startOf('day');
  const start = record.date_start ? Moment(record.date_start).startOf('day') : null;
  const end = record.date_end ? Moment(record.date_end).endOf('day') : null;
  if (start && start.isAfter(today)) return 'upcoming';
  if (end && end.isBefore(today)) return 'past';
  return 'ongoing';
}

export function bucketAndSortMedicationRecords(records) {
  const order = { ongoing: 0, upcoming: 1, past: 2 };
  return [...records]
    .map((r) => ({ ...r, _bucket: getMedicationRecordBucket(r) }))
    .sort((a, b) => {
      if (order[a._bucket] !== order[b._bucket]) return order[a._bucket] - order[b._bucket];
      if (a._bucket === 'past') return Moment(b.date_end).valueOf() - Moment(a.date_end).valueOf();
      return Moment(a.date_start).valueOf() - Moment(b.date_start).valueOf();
    });
}

const MedicationRecordList = ({ records, onSelect }) => {
  if (!records || records.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <i className="ri-medicine-bottle-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
        <p>No records available</p>
      </div>
    );
  }
  return (
    <div>
      {records.map((record) => {
        const meta = MEDICATION_BUCKET_META[record._bucket] || MEDICATION_BUCKET_META.past;
        return (
          <div
            key={record.id}
            onClick={() => onSelect(record)}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 16px', marginBottom: '8px', borderRadius: '8px',
              border: '1px solid #e5e7eb', background: 'white', cursor: 'pointer',
              transition: 'box-shadow 0.15s ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div>
              <div style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>
                {record.medication_name || 'Medication'}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                {formatDisplayDate(record.date_start)}
                {' - '}
                {formatDisplayDate(record.date_end)}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{
                fontSize: '11px', fontWeight: '700', padding: '4px 10px', borderRadius: '20px',
                background: meta.bg, color: meta.color, whiteSpace: 'nowrap',
              }}>
                <i className={meta.icon} style={{ marginRight: '4px' }}></i>{meta.label}
              </span>
              <i className="ri-arrow-right-s-line" style={{ fontSize: '18px', color: '#9ca3af' }}></i>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MedicationRecordList;
